/**
 * File Name          : ble-browser.guard.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

export const chromiumBrowserGuard: CanActivateFn = () => {
  const router = inject(Router);

  const platform = Capacitor.getPlatform();

  // Allow immediately on native iOS/Android
  if (platform !== 'web') {
    return true;
  }

  // Browser is WEB → must be Chromium-based
  const ua = navigator.userAgent;
  const isOpera = /OPR\/\d+/.test(ua) || /Opera\/\d+/.test(ua);
  const isChromium =
    /Chrome\/\d+/.test(ua) ||   // Chrome, Brave, Opera, etc.
    /Edg\/\d+/.test(ua) ||      // Edge
    /Chromium\/\d+/.test(ua);   // Explicit Chromium builds

  if (!isChromium || isOpera) {
    return router.navigate(['unsupported-browser']);
  }

  return true;
};